import { materialize } from "../materializer/index.mjs";
import { defineFor } from "../program-infer/index.mjs";
import { makeTagged } from "../tagged-union/index.mjs";
export function makeSummoner(cacheProgramEval, programInterpreter) {
  const summon = F => materialize(cacheProgramEval(F), programInterpreter);

  const tagged = makeTagged(summon);
  const define = defineFor(undefined)();
  return {
    make: summon,
    makeADT: tagged,
    makeProgram: define
  };
}
//# sourceMappingURL=index.mjs.map